import http from "@/shared/services/http";

export const createWardV21 = (data: any) => http.post(`v1/regions/wards/create`, data);
export const singleWardV21 = (id: number) => http.get(`v1/regions/wards/single/${id}`);
export const editWardV21 = (data: any) => http.put(`v1/regions/wards/edit/${data.id}`, data);
export const listWardV21 = (params: any = {}) => http.get(`v1/regions/wards/list`, { params });
export const deleteWardV21 = (id: number) => http.delete(`v1/regions/wards/delete/${id}`);
